import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css';
// Locals
import ar from 'vuetify/src/locale/ar';
import en from 'vuetify/src/locale/en';

import {
  VApp,
  VMain,
  VBtn,
  VRow,
  VCol,
  VImg,
  VForm,
  VIcon,
  VSpacer,
  VSelect,
  VTextField,
  VContainer,
  VBreadcrumbs,
  VBreadcrumbsItem,
  VInput,
} from 'vuetify/lib/components';

Vue.use(Vuetify, {
  components: {
    VApp,
    VMain,
    VBtn,
    VRow,
    VCol,
    VImg,
    VIcon,
    VForm,
    VSelect,
    VSpacer,
    VTextField,
    VContainer,
    VBreadcrumbs,
    VBreadcrumbsItem,
    VInput,
  },
});

export default new Vuetify({
  rtl: true,
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { ar, en },
    current: 'ar',
  },
  theme: {
    themes: {
      light: {
        primary: '#158E8D',
        secondary: '#e0cf97',
      },
    },
  },
});
